import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Subject } from 'rxjs';
import { Booking, BookingsStore } from '@fry/booking/lib/bookings';
import { BookingOptionDoc } from '@fry/booking/lib/booking-items/booking-option';
import { EasTable } from '@fry/lib/store';
import { LoaderLoadingState, LoaderReadyState, LoaderState, LoaderWaitingState } from '@fry/components/common/loader';

export interface ExtendedBooking {
  obj: Booking;
  row: [];
}

export interface Column {
  id: string;
  label: string;
  type?: string;
}

@Component({
    selector: 'eas-booking-item-integration-option',
    templateUrl: './booking-item-integration-option.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingItemIntegrationOptionComponent implements OnInit {
  @Input() bookingItemOption: BookingOptionDoc;

  public tables: EasTable[];
  public loadingState: LoaderState = LoaderWaitingState;
  public ready = new Subject<boolean>();

  constructor(
      private bookings: BookingsStore,
  ) { }

  ngOnInit() {
  }

  init() {
    this.loadingState = LoaderLoadingState;
    this.loadBookings();
    return this.ready;
  }

  loadBookings() {
    const params = {
      bookingItem: [this.bookingItemOption.bookingItem._id],
      bookingOption: [this.bookingItemOption.id],
    };
    this.bookings.integrationCheck(params).pipe(
    ).subscribe(
      data => {
        this.tables = data;
        this.loadingState = LoaderReadyState;
      },
      err => {
        this.loadingState = {
          state: 'error',
          error: err,
        };
        this.ready.next(true);
        this.ready.complete();
      },
      () => {
        this.ready.next(true);
        this.ready.complete();
      });
  }
}
